module.exports = __webpack_public_path__ + "img/temperature-green.5aa5a0a1.svg";